var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var curry = require('ramda/src/curry');
var objAccumulator = function objAccumulator(accumulator, transformed, original) {
  accumulator[original[0]] = transformed;
};
var aryAccumulator = function aryAccumulator(accumulator, transformed) {
  accumulator.push(transformed);
};
var makeEvaluator = function makeEvaluator(func, iterator, accFunc, accumulator) {
  var evaluator = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var next;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              next = iterator.next();
              if (!next.done) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.t0 = accFunc;
              _context.t1 = accumulator;
              _context.next = 7;
              return func(next.value);
            case 7:
              _context.t2 = _context.sent;
              _context.t3 = next.value;
              (0, _context.t0)(_context.t1, _context.t2, _context.t3);
              _context.next = 12;
              return evaluator();
            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function evaluator() {
      return _ref.apply(this, arguments);
    };
  }();
  return evaluator;
};

/**
 * A promise map helper, runs an async function on each item one after the other.
 * Given an asynchronous function and an iterable or an object, this will evaluate the
 * function against each value of the iterable.
 *
 * If the given iterable is neither iterable nor an object, it is just returned.
 *
 * Note: An iterable will always return a promise for an array. An object will return a promise
 * for an object.
 *
 * @func
 * @memberof module:omnibelt
 * @name mapSerialP
 *
 * @param {Function} func - An async function
 * @param {Iterable} iterable - Object or iterable
 * @return {Promise} A promise that will resolve to either an array or object when iteration is done
 * @summary Function -> Iterable -> Promise<iterable>
 */
var mapSerialP = curry( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(func, iterable) {
    var accumulator, evaluator;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (iterable) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", iterable);
          case 2:
            if (!iterable[Symbol.iterator]) {
              _context2.next = 7;
              break;
            }
            accumulator = [];
            evaluator = makeEvaluator(func, iterable[Symbol.iterator](), aryAccumulator, accumulator);
            _context2.next = 13;
            break;
          case 7:
            if (!(typeof iterable === 'object')) {
              _context2.next = 12;
              break;
            }
            accumulator = {};
            evaluator = makeEvaluator(func, Object.entries(iterable)[Symbol.iterator](), objAccumulator, accumulator);
            _context2.next = 13;
            break;
          case 12:
            return _context2.abrupt("return", iterable);
          case 13:
            _context2.next = 15;
            return evaluator();
          case 15:
            return _context2.abrupt("return", accumulator);
          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
module.exports = mapSerialP;